import type {SVGProps} from 'react'

const ForwardFilled = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.2785 15.4765" {...props}>
        <g>
            <path d="M1.74512 13.9424C1.74512 14.9623 2.35957 15.4668 3.07597 15.4668C3.39257 15.4668 3.71444 15.3701 4.03104 15.1928L14.4318 9.13709C15.1976 8.68983 15.5406 8.30956 15.5406 7.73339C15.5406 7.15546 15.1976 6.77695 14.4318 6.32968L4.03104 0.274022C3.71444 0.0886714 3.39257 0 3.07597 0C2.35957 0 1.74512 0.494724 1.74512 1.5164ZM15.483 13.9424C15.483 14.9623 16.0894 15.4668 16.8138 15.4668C17.1224 15.4668 17.4523 15.3701 17.7689 15.1928L28.1617 9.13709C28.9355 8.68983 29.2785 8.30956 29.2785 7.73339C29.2785 7.15546 28.9355 6.77695 28.1617 6.32968L17.7689 0.274022C17.4523 0.0886714 17.1224 0 16.8138 0C16.0894 0 15.483 0.494724 15.483 1.5164Z" />
        </g>
    </svg>
)
export default ForwardFilled
